<template>
  <section class="blog-text-box-new">
    <a :href="shopifyData.secLink ? shopifyData.secLink : '#'" :style="customizeContent">
      <div class="blog_content">
        <h2 class="blog_Heading" :style="textColor" v-html="shopifyData.blogHeading" />
      </div>
    </a>
  </section>
</template>
<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },

  computed: {
    customizeContent() {
      return {
        'padding-top':
          window.innerWidth > 768
            ? `${this.shopifyData.deskPaddingTop}px`
            : `${this.shopifyData.mobPaddingTop}px`,
        'padding-bottom':
          window.innerWidth > 768
            ? `${this.shopifyData.deskPaddingBottom}px`
            : `${this.shopifyData.mobPaddingBottom}px`,
        background: `${this.shopifyData.bgColor}`,
      };
    },
    textColor() {
      return {
        color: `${this.shopifyData.textColor}`,
      };
    },
  },
  mounted() {
    this.myMethod();
  },
  methods: {
    myMethod() {},
  },
};
</script>

<style scoped>
.blog_content {
  max-width: 816px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
}
.blog-text-box-new a {
  display: block;
}
.blog_Heading {
  color: #f00;
  text-align: center;
  font-family: 'Helvetica Neue', sans-serif;
  font-size: 48px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

@media (max-width: 767px) {
  .blog_Heading {
    font-size: 30px;
  }
}

/* Responsive Breakpoints */
</style>
